// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "client-viewer/" + ({"227":"SignupRootWidget","315":"DesktopResponsiveRootWidget","368":"Toast","513":"MobileRootWidget","964":"DesktopNonResponsiveRootWidget"}[chunkId] || chunkId) + ".chunk.min.js";
};